import React, { Component } from 'react';
import querystring from 'query-string';
import { ApiGetKushkiTranStatus } from '@/api/index';
import store from '@/store/index';
import {
  getQueryVariable,
  changeIco,
  $t,
  getProxyConfig,
  getArray2Name,
  AppList,
} from '@/utils/utils';
import { Domain2App } from '@/utils/app';

class WaittingRepaymentResult extends Component {
  constructor(props) {
    super(props);

    let app = getQueryVariable('app');
    app = /^[0-9]/.test(app) ? '_' + app : app // 如果是数字开头,那么就在前面上下划线
    if (!app) { // 如果没有带app参数 则使用域名配置
      app = Domain2App[window.location.host] || 'xcredit';
    }

    app = app.toLowerCase(); // 全部转小写
    const rules = getArray2Name(AppList, app);
    store.dispatch({ type: 'set-i18n', data: rules.i18n || 'en_US' })


    this.state = {
      app,
      appData: null, // 请求头
    };
  }

  handleOKClick(){
    if (window.android) {
      window.android.trackEvent('h5_repaymentprocessing_ok_click', null);
      window.android.jumpToHome();
    }
  }
  
  // 秘鲁银行转账需要跳转到该页面并调用一个银行接口
  // 调用即可 无需知道结果
  getStatus() {
    const { app, appData } = this.state

    if (app !== 'isolez') return;

    const query = querystring.parse(window.location.search)
    ApiGetKushkiTranStatus({
      headers: appData,
      data: {
        appId: 'iSolez',
        token: query.token || '',
      },
      ...getProxyConfig(app),
    })
  }
  getAppData() {
    if (window.android) {
      const json = window.android.getRequestHeaders();

      const data = json ? JSON.parse(json) : null;
      this.setState({
        appData: Object.assign({}, this.state.appData, data),
      })
    } else {
      const data = {
        Authorization: 'Bearer 16C57D73827FD18564B6F8289A65B5FD931D8AB3EEA7D0370FF3C72046E49F53',
      }
      this.setState({
        appData: Object.assign({}, this.state.appData, data),
      })
    }
  }
  componentDidMount(){
    document.title = $t('payResult');
    changeIco(this.state.app);

    this.getAppData();
    setTimeout(() => {
      this.getStatus();
    }, 80)
  }
  render() {
    const { app } = this.state

    // 支付方式
    let paymentMethod = 'M-PESA';
    let payClass = ''
    if (['xcredit', 'imoney', 'credit9ja', '_9jacash', 'nownowmoney,', 'isolez', 'mocash', 'naira9ja', 'caja'].includes(app)) {
      paymentMethod = ''
      payClass = 'pay-methods'
    }

    // 等待svg
    let waittingImg = <embed src='https://static-af.obs.af-south-1.myhuaweicloud.com/web/app-h5/svg/wait.svg'></embed>;
    const newUiApp = [
      'kashway', 'ipesa', 'creditmoja',
      'xcredit', 'imoney', 'credit9ja', 'naira9ja', '_9jacash', 'nownowmoney',
      'ucredit', 'usente', 'isente',
      'ipeso', 'creavicash',
      'isolez','caja',
      'tifi',
      'champloan',
      'mangucash',
      'parcecredit',
      'credifio-co',
      'tifislice',
    ]
    const repaySvg = window.$localCdnLink +'/app/'+ app +'/loan-processing/waitting-repay.svg'
    if (newUiApp.includes(app)) {
      waittingImg = <embed src={ repaySvg }></embed>;
    }
    //  圆形按钮的svg图标
    const btnSvg = ['caja','isolez'].includes(app) ? <div
      className='radius-btn'
    /> : null

    const btnMsg = { // 不同国家不同映射
      'parcecredit' : $t('confirmar'),
      'credifio-co' : $t('confirmar')
    }
    
    const localClass = 'WaittingRepaymentResult ' + app;

    let message = <p><span className={ payClass }>{ paymentMethod } { $t('repayment') }</span> { $t('accepted') }, { $t('waitResponse') }</p>
    const msgTypeOne = <p>Repayment Processing, please wait a few minutes for the response</p>
    const msgTypeTwo = <p>Procesamiento de pagos, por favor espere, espere los resultados</p>
    const msgTypeThree = <p>Por favor, espere mientras se procesa la solicitud de reembolso.</p>
    const msgTypeFour = <p>Por favor, espere mientras se procesa su pago</p>
    // const msgTypeFive = <p>Yo payments repayment accepted, please wait a few minutes for the response</p>
    const msgTypeDefault = <p>Por favor, espere mientras se procesa su pago</p>
    const messageMap = {
      'xcredit': msgTypeOne,
      '_9jacash': msgTypeOne,
      'nownowmoney': msgTypeOne,
      'ucredit': msgTypeOne,
      'usente': msgTypeOne,
      'mangucash': msgTypeOne,
      'imoney': msgTypeOne,
      'naira9ja': msgTypeOne,
      '9jaCash': msgTypeOne,
      // 'nownowmoney': msgTypeOne,
      'kashway': msgTypeOne,
      'creditmoja': msgTypeOne,
      'ipesa': msgTypeOne,
      'tifi': msgTypeTwo,
      'parcecredit': msgTypeThree,
      'credifio-co': msgTypeThree,
      'champloan': msgTypeFour,
      'isente': msgTypeOne,
      'default': msgTypeDefault
    }
    message = messageMap[app] || messageMap['default']
    const titleMap = {
      'champloan': 'Aplicando su pago',
      'parcecredit': 'En proceso',
      'credifio-co': 'En proceso',
    }
    const title = titleMap[app] || $t('repaymentProcessing')

    return <div className={localClass}>
      <div className='content'>
        <div className='title'>
          <span>{ title }</span>
          <div className='waittingImg'>
            { waittingImg }
          </div>
        </div>
      </div>
      <div className='foot_support'>
        { message }

        <button onClick={this.handleOKClick}>
          {
            btnSvg || btnMsg[app] || 'ok'
          }
        </button>
      </div>
    </div>
  }
}

export default WaittingRepaymentResult;
